
import { Input,Component } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular/standalone';
import { IonApp,IonSelect, IonButtons,IonInput, IonItemDivider,IonHeader,IonToolbar, IonTitle, IonSelectOption, IonSplitPane, IonButton,IonMenu, IonContent, IonList, IonListHeader, IonNote, IonMenuToggle, IonItem, IonIcon, IonLabel, IonRouterOutlet, IonRouterLink } from '@ionic/angular/standalone';

import { CommonModule } from '@angular/common';


  @Component (
    {
      selector:'app-marker',
      template:`<ion-header><ion-title>Select Marker></ion-title>
      <ion-header> <ion-item (click)='selectComp(comp)'  [color]="selected(comp)?'success':''"  
      *ngFor="let comp of ['N','T','S','K']">{{comp}} {{selected(comp)?'selected':'' }}</ion-item>
    
      <ion-button (click)='dismissThis()' > Done</ion-button>`,
      imports: [CommonModule, IonHeader, IonTitle,IonItem,
        IonButton
        
      ]}
  )
  
  export class MarkerComp
  {
    @Input('markers') markers:any[]=[];
    @Input ('index')  index:number=0;
    constructor(private modalC:ModalController)
    {
  
    }
    dismissThis()
    {
      this.modalC.dismiss();
    }
    selectComp(marker:any)
    {
        
      if (this.markers) 
        if (this.index != null)
            
              this.markers[this.index]=marker;
    }
    selected(marker:any)
    {
        if (this.markers) 
            if (this.index != null)
                if (this.markers[this.index]) 
                {
                    //console.log ('returning ', this.markers[this.index]==marker);
                    return (
                            this.markers[this.index]==marker);
                }
        return false;
    }
    /* Usage 
    const modal = await this.modalController.create({
    component: MakerComp
      componentProps: {
        markers: []// array of markers
        index: 0  // index to what is being operated
      }
    });
    await modal.present();
    */
  
  
  }